<template>
  <HeroSection />
  <Brands />
  <AboutSection />
  <ProductOverviewSection />
</template>

<script>
import HeroSection from "@/components/HomePage/HeroSection.vue";
import Brands from "@/components/HomePage/ReusableComponents/Brands.vue";
import AboutSection from "@/components/HomePage/AboutSection.vue";
import ProductOverviewSection from "@/components/HomePage/ProductOverviewSection.vue";

export default {
  name: "HomePage",
  components: {
    HeroSection,
    Brands,
    AboutSection,
    ProductOverviewSection,
  },
};
</script>

<style></style>
